import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

import {Box, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {PhoneForwardedIcon} from "@hugeicons/core-free-icons";
import {getPalette, hexToRgba, NODE_RADIUS, NODE_SHADOW} from "./nodeTheme";


function TransferCallNode({ id, data, selected }) {

    const {name} = data;
    const palette = getPalette("transfer");

    return (
        <Box className={"node transfer-call-node"} sx={{
            width: "auto",
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            bgcolor: palette.accent,
            px: 1, py: 0.6,
            borderRadius: `${NODE_RADIUS}px`,
            border: "1px solid",
            borderColor: palette.accent,
            boxShadow: selected ? `${NODE_SHADOW}, 0 0 0 3px ${hexToRgba(palette.accent, 0.3)}` : NODE_SHADOW,
            transition: "box-shadow .18s ease",
        }}>
            <Handle type="target" position={Position.Left} id={id} />
            <Box sx={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 18, height: 18, borderRadius: "6px",
                background: hexToRgba("#FFFFFF", 0.18), color: "#FFFFFF", flexShrink: 0,
            }}>
                <HugeiconsIcon icon={PhoneForwardedIcon} size={11} strokeWidth={1.8} color={"#FFFFFF"} />
            </Box>
            <Typography noWrap sx={{fontSize: 10, fontWeight: 600, color: "#FFFFFF", letterSpacing: "0.01em"}}>
                {name || "Transfer Call"}
            </Typography>
        </Box>
    );
}

export default memo(TransferCallNode);
